module.exports = __webpack_public_path__ + "static/media/submit-bid-icon.fb0e2f7e.svg";